import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  Drawer,
  Typography,
} from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useMemo, useState } from "react";
import { usersAdminGet, userEdit, userDelete } from "../../api/api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-mui";
import React from "react";
import phone from "phone";
import { useSnackbar } from "../../store/store";
import MuiPhoneNumber from "material-ui-phone-number-2";
import { omit } from "lodash";
import { useCallback } from "react";

export const Users = ({ selectedBusiness }: { selectedBusiness: any }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [selected, setSelected] = useState<any | null>(null);
  const snackbar = useSnackbar();
  const queryClient = useQueryClient();

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfBusinessesResponse } = useQuery(
    'getUserAdminOfBusinesses',
    getUserAdminOfBusinesses,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfBusinesses = getUserAdminOfBusinessesResponse!.data;

  const [selectedBusinessId, setSelectedBusinessId] = useState<number>(
    userAdminOfBusinesses[0]?.id,
  );
  */

  console.log("selected", selected);

  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery(
    ["usersAdminGet", selectedBusiness?.id],
    usersAdminGet(selectedBusiness?.id),
    {
      enabled: !!selectedBusiness?.id,
      refetchOnWindowFocus: false,
    }
  );
  const data: any = response?.data;

  const {
    mutateAsync,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation("userEdit", userEdit, {
    onError: (err: any) => {
      alert("Error", err.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries(["profile", "usersAdminGet"]);
      refetch();
    },
  });

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.length) {
      return { rowData: [] };
    }
    const columnDefs: ColDef[] = [
      {
        field: "username",
        headerName: "Username",
        sortable: true,
        initialSort: "asc",
        flex: 1,
        minWidth: 160,
        filter: true,
      },
      {
        field: "phone",
        headerName: "Phone",
        sortable: true,
        flex: 1,
        minWidth: 94,
      },
      {
        field: "familyName",
        headerName: "Family name",
        sortable: true,
        flex: 1,
        minWidth: 94,
      },
      {
        field: "givenName",
        headerName: "Given name",
        sortable: true,
        flex: 1,
        minWidth: 160,
      },
    ];

    return { columnDefs, rowData: data };
  }, [data]);

  const handlePhoneChange = useCallback(
    (originalHandler) => (value) => {
      originalHandler({ target: { name: "phone", value } });
    },
    []
  );

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: "100vw", sm: "600px" } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: "1.3em", fontWeight: 500, m: "16px 24px" }}
            >
              {!!selected ? "Edit user" : "Add user"}
            </Typography>
            <Divider />
            <Box sx={{ padding: "24px" }}>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
              {/*
              {!selected &&
                'Enter the email address of the registered user you want give permissions to the business.'}
              */}
              <Formik
                validateOnMount
                initialValues={
                  selected || {
                    givenName: selected?.givenName || "",
                    familyName: selected?.familyName || "",
                    email: selected?.email || "",
                    password: "",
                    confirmPassword: "",
                    phone: selected?.phone || "",
                  }
                }
                validationSchema={Yup.object().shape({
                  givenName: Yup.string()
                    .min(2, "Too short")
                    .max(50, "Too long")
                    .required("Required"),
                  familyName: Yup.string()
                    .min(2, "Too short")
                    .max(50, "Too long")
                    .required("Required"),
                  email: Yup.string()
                    .email("Invalid email")
                    .required("Required"),
                  phone: Yup.string()
                    .test("phone", "Invalid phone number", (value) => {
                      if (!value) return true;
                      return phone(value).isValid;
                    })
                    .required("Required"),
                  password: Yup.string()
                    .min(8, "Too short")
                    .max(50, "Too long")
                    .required("Required"),
                  confirmPassword: Yup.string().oneOf(
                    [Yup.ref("password"), null],
                    "Those passwords didn’t match. Try again."
                  ),
                })}
                onSubmit={async (values, { setSubmitting }) => {
                  //console.log(values);
                  try {
                    const res = await mutateAsync({
                      values: omit(values, ["confirmPassword"]),
                    });
                    const verify = res.data.verify;
                    if (verify) {
                      snackbar.open({
                        type: "success",
                        message: `Verification email was sent to ${values.email}`,
                      });
                    } else {
                      queryClient.invalidateQueries("profile");
                    }
                    refetch();
                    setSubmitting(false);
                    setRightDrawerOpen(false);
                  } catch (error: any) {
                    alert(error.error, error.message);
                  }
                  setSubmitting(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                  setFieldValue,
                }) => (
                  <Form style={{ width: "100%" }}>
                    <Box
                      sx={{
                        width: "100%",
                        marginInline: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        position: "relative",
                      }}
                    >
                      <Field
                        component={TextField}
                        label="Given name"
                        name="givenName"
                        size="small"
                      />
                      <Field
                        component={TextField}
                        label="Family name"
                        name="familyName"
                        size="small"
                      />
                      <Field
                        component={TextField}
                        label="Email"
                        name="email"
                        size="small"
                      />
                      <Field
                        type="password"
                        component={TextField}
                        label="Password"
                        name="password"
                        size="small"
                      />
                      <Field
                        type="password"
                        component={TextField}
                        label="Confirm password"
                        name="confirmPassword"
                        size="small"
                      />

                      <MuiPhoneNumber
                        required
                        size="small"
                        defaultCountry={"rw"}
                        name="phone"
                        label="Phone"
                        variant="outlined"
                        value={values?.phone}
                        onBlur={handleBlur}
                        onChange={handlePhoneChange(handleChange)}
                        error={touched.phone && !!errors.phone}
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        helperText={touched.phone && errors.phone}
                        className="MuiPhoneNumber"
                        InputLabelProps={{ required: false }}
                      />
                      <Box
                        sx={{
                          textAlign: "right",
                          margin: "16px 0",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => setRightDrawerOpen(false)}
                          sx={{ padding: "6px 8px" }}
                        >
                          Cancel
                        </Button>

                        <Box sx={{ flex: "1 1 auto" }} />
                        {!!selected && (
                          <Button
                            color="primary"
                            disabled={isSubmitting}
                            onClick={() => setDialogOpen(true)}
                            sx={{ padding: "6px 8px" }}
                          >
                            Delete
                          </Button>
                        )}
                        <Box sx={{ flex: "1 1 auto" }} />
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={isSubmitting || !isValid}
                          sx={{ padding: "6px 24px" }}
                          onClick={submitForm}
                        >
                          {!!selected ? "Save" : "Add"}
                        </Button>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deletion confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? An owner of an business cannot be deleted. This cannot be undone.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await userDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexGrow: 0,
            alignItems: "center",
            gap: 1,
            height: "56px",
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: "1.25rem",
            }}
          >
            Users
          </Typography>
          {/*
          <Button
            color="primary"
            onClick={() => {
              setSelected(null);
              setRightDrawerOpen(true);
            }}
          >
            <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
            Add new
          </Button>
          */}
        </Box>
        <Card
          className="ag-theme-material"
          sx={{
            borderRadius: 0,
            margin: "0 -16px -16px",
            display: "flex",
            overflow: "hidden",
            flexGrow: 1,
            height: "100%",
            boxShadow: "none !important",
          }}
        >
          {isFetching && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Box sx={{ display: isFetching ? "none !important" : "block" }}>
            <AgGridReact
              className="ag-pointer-row"
              rowData={rowData}
              pagination={true}
              floatingFiltersHeight={50}
              paginationAutoPageSize={true}
              columnDefs={columnDefs}
              onRowClicked={({ data }) => {
                setSelected(data);
                setRightDrawerOpen(true);
              }}
            ></AgGridReact>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default Users;
